import { Flex, Text } from "@chakra-ui/react";
import { cloneElement, ReactElement } from "react";

interface FilterTitleProps {
  text: string;
  activeFilters?: number;
  open?: boolean;
  icon?: ReactElement;
}

export function FilterTitle({
  text,
  activeFilters = 0,
  open = false,
  icon,
}: FilterTitleProps) {
  const iconColor = open ? "blaze.300" : "neutral.400";
  const hasActive = activeFilters > 0;
  return (
    <Flex align="center" justify="space-between" w="full" role="group">
      <Flex gap="8px" align="center">
        {icon && cloneElement(icon, { color: iconColor })}
        <Text fontSize="14px" fontFamily="Roboto" whiteSpace="nowrap" color="white" lineHeight="1.3" fontWeight="400" letterSpacing="0.5px">
          {text}
        </Text>
      </Flex>
      {hasActive && (
        <Text fontFamily="Roboto" fontSize="10px" fontWeight="400" whiteSpace="nowrap" lineHeight="1.3" letterSpacing="0.5px" color="charcoal.300" pr="6px">
          {activeFilters}
        </Text>
      )}
    </Flex>
  );
}
